export type LoaderType = 'none' | 'spinner' | 'multi-step';

import { HttpContextToken } from '@angular/common/http';

export const LOADER_TYPE = new HttpContextToken<LoaderType>(() => 'spinner');
